import React, { useContext, useEffect, useRef, useState } from "react";
import { BsCart3 } from "react-icons/bs";
import { MdOutlineMenu } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom";
import CartContext from "../context/CartContext";
import DropDown from "./DropDown";
import { CiUser } from "react-icons/ci";
import { BiSearch } from "react-icons/bi";
import { LiaTimesSolid } from "react-icons/lia";

function Nav() {
  const { prod, setProd } = useContext(CartContext);
  const [toggle, setToggle] = useState(false);
  const [cart, setCart] = useState(false);
  const [search, setSearch] = useState();
  const ulRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    if (!prod.length) {
      const i = localStorage.getItem("cart");
      if (i) {
        setProd(JSON.parse(i));
      }
    }
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (search) {
      navigate(`/search/${search}`);
    }
  };

  return (
    <nav className="nav">
      <div className="nav-con">
        <p
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "rgb(59, 59, 59)",
          }}
        >
          <img src={require("../public/croped2.png")} width={"55px"} />
          <b>Swingwings</b>
        </p>
        <form className="search" onSubmit={(e) => handleSearch(e)}>
          <input
            type="text"
            placeholder="Search for book"
            onChange={(e) => setSearch(e.target.value)}
          />
          <button>
            <BiSearch size={20} />
          </button>
        </form>
        <ul>
          <NavLink
            to={"/"}
            style={({ isActive }) => ({
              color: "black",
              textDecoration: "none",
              borderBottom: isActive
                ? "3px solid #ffb700"
                : "3px solid transparent",
            })}
          >
            <li>Home</li>
          </NavLink>
          <NavLink
            to={"/product/all"}
            style={({ isActive }) => ({
              color: "black",
              textDecoration: "none",
              borderBottom: isActive
                ? "3px solid #ffb700"
                : "3px solid transparent",
            })}
          >
            <li>Products</li>
          </NavLink>
          <NavLink
            to={"/about"}
            style={({ isActive }) => ({
              color: "black",
              textDecoration: "none",
              borderBottom: isActive
                ? "3px solid #ffb700"
                : "3px solid transparent",
            })}
          >
            <li>About</li>
          </NavLink>
          {/*<div>
            <span onClick={() => navigate("/cart")}>
              <article>{prod.length}</article>
              <BsCart3 size={25} />
            </span>
            {localStorage.getItem("token") ? (
              <CiUser size={25} />
            ) : (
              <button className="btn" onClick={() => navigate("/login")}>
                Login
              </button>
)}
          </div>*/}
        </ul>

        <span className="menu">
          {/*<span onClick={() => navigate("/cart")}>
            <article>{prod.length}</article>
            <BsCart3 size={25} />
          </span>*/}
          {!toggle ? (
            <MdOutlineMenu onClick={() => setToggle(!toggle)} />
          ) : (
            <b onClick={() => setToggle(!toggle)}>
              <LiaTimesSolid />
            </b>
          )}
        </span>
        <DropDown toggle={toggle} setToggle={setToggle} ulRef={ulRef} />
      </div>
    </nav>
  );
}

export default Nav;
